import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  selectIsSearch,
  selectSearchQuery,
} from '../redux/features/dashboard/dashboardSelectors';
import { showSearch } from '../redux/features/dashboard/dashboardSlice';

export const useReturnToMain = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSearchShown = useSelector(selectIsSearch);
  const searchQueryData = useSelector(selectSearchQuery);

  const returnToMain = () => {
    if (isSearchShown) {
      dispatch(
        showSearch({
          isSearchVisible: false,
          searchQuery: searchQueryData,
          searchFilters: '',
        })
      );
    }
    navigate('/', { replace: true });
  };

  return returnToMain;
};
